<div class="modal-loading--wrapper">
  <div class="modal-loading--content">
    <div class="modal-loading--content--title">
      <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold nx-margin-bottom-3m">
        {{ 'azForm.modal.loading.title' | translate }}
      </h3>
    </div>

    <div class="modal-loading--content--text">
      <div class="modal-loading--content--text_center">
        <nx-spinner size="large"></nx-spinner>
      </div>
    </div>
  </div>
</div>
